import React, { useState, useEffect } from 'react';
import Sidebar from './side/Sidebar';
import '../css/ServerStatus.css';
import axios from 'axios';
import { SERVER_URL } from '../../config/config';

const ServerStatus = () => {
  const [serverData, setServerData] = useState({
    cpu: 0,
    memory: 0,
    disk: 0,
    uptime: '0day 0hours'
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState(null);

  const fetchServerStatus = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/admin/server/status`);
      if (response.data) {
        setServerData(response.data);
        setError(null);
      }
    } catch (err) {
      setError('서버 상태를 불러오는데 실패했습니다.');
      console.error('Server status fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServerStatus();
    // 2초마다 서버 상태 업데이트
    const interval = setInterval(fetchServerStatus, 2000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    console.log(serverData);
  }, [serverData]);

  const cpuWarning = serverData.cpu >= 90;

  const handleMetricClick = (metric) => {
    setSelectedMetric(metric);
    setShowDetailModal(true);
  };

  const metricDetails = {
    cpu: {
      title: 'CPU 사용량',
      description: '서버의 CPU 사용량을 실시간으로 모니터링합니다. 90% 이상일 경우 경고 상태가 됩니다.',
      recommendations: [
        '불필요한 프로세스 종료',
        'CPU 사용량이 높은 프로세스 확인',
        '서버 리소스 확장 고려'
      ]
    },
    memory: {
      title: '메모리 사용량',
      description: '서버의 메모리 사용량을 실시간으로 모니터링합니다.',
      recommendations: [
        '메모리 누수 확인',
        '불필요한 캐시 정리',
        '메모리 사용량이 높은 프로세스 확인'
      ]
    },
    disk: {
      title: '디스크 사용량',
      description: '서버의 디스크 사용량을 실시간으로 모니터링합니다.',
      recommendations: [
        '불필요한 파일 정리',
        '로그 파일 관리',
        '디스크 공간 확장 고려'
      ]
    }
  };

  const clampPercent = (value) => Math.max(0, Math.min(100, value));

  if (loading) {
    return (
      <div className="user-management" id="server-status">
        <div className="content-wrapper">
          <Sidebar />
          <div className="main-content">
            <div className="loading">서버 상태를 불러오는 중...</div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="user-management" id="server-status">
        <div className="content-wrapper">
          <Sidebar />
          <div className="main-content">
            <div className="error">{error}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="user-management" id="server-status">
      <div className="content-wrapper">
        <Sidebar />
        <div className="main-content">
          <div className="header-section">
            <h1>
              <span className={`status-icon ${cpuWarning ? 'warning' : 'normal'}`}>
                {cpuWarning ? '❗' : '🟢'}
              </span>
              Server Status
            </h1>
            {/* <div className="server-desc">Real-time monitoring of your server resources</div> */}
          </div>

          <div className="table-container">
            <div className="status-row" onClick={() => handleMetricClick('cpu')}>
              <div className="status-label">CPU</div>
              <div className="status-bar-outer" style={{ position: 'relative' }}>
                <div className="status-bar-inner cpu" style={{width: `${clampPercent(serverData.cpu)}%`}}></div>
                <span className="status-bar-label" style={{ 
                  position: 'absolute', 
                  left: '50%', 
                  top: '50%', 
                  transform: 'translate(-50%, -50%)',
                  zIndex: 1,
                  color: '#000',
                  fontWeight: 'bold'
                }}>{serverData.cpu}%</span>
              </div>
              {cpuWarning && <div className="status-warning-text">CPU 사용률이 90프로 이상입니다.</div>}
            </div>
            <div className="status-row" onClick={() => handleMetricClick('memory')}>
              <div className="status-label">메모리</div>
              <div className="status-bar-outer" style={{ position: 'relative' }}>
                <div className="status-bar-inner memory" style={{width: `${clampPercent(serverData.memory)}%`}}></div>
                <span className="status-bar-label" style={{ 
                  position: 'absolute', 
                  left: '50%', 
                  top: '50%', 
                  transform: 'translate(-50%, -50%)',
                  zIndex: 1,
                  color: '#000',
                  fontWeight: 'bold'
                }}>{serverData.memory}%</span>
              </div>
            </div>
            <div className="status-row" onClick={() => handleMetricClick('disk')}>
              <div className="status-label">디스크</div>
              <div className="status-bar-outer" style={{ position: 'relative' }}>
                <div className="status-bar-inner disk" style={{width: `${clampPercent(serverData.disk)}%`}}></div>
                <span className="status-bar-label" style={{ 
                  position: 'absolute', 
                  left: '50%', 
                  top: '50%', 
                  transform: 'translate(-50%, -50%)',
                  zIndex: 1,
                  color: '#000',
                  fontWeight: 'bold'
                }}>{serverData.disk}%</span>
              </div>
            </div>
            <div className="status-row uptime-row">
              <div className="status-label">서버 가동 시간</div>
              <div className="uptime-value" style={{ marginLeft: '10px' }}>{serverData.uptime}</div>
            </div>
          </div>
        </div>
      </div>

      {/* 상세 정보 모달 */}
      {showDetailModal && selectedMetric && (
        <div className="param-desc-modal-overlay" onClick={() => setShowDetailModal(false)}>
          <div className="param-desc-modal" onClick={e => e.stopPropagation()}>
            <div className="param-desc-title">{metricDetails[selectedMetric].title}</div>
            <div className="param-desc-content">
              <p>{metricDetails[selectedMetric].description}</p>
              <div className="recommendations">
                <h4>권장 조치사항:</h4>
                <ul>
                  {metricDetails[selectedMetric].recommendations.map((rec, index) => (
                    <li key={index}>{rec}</li>
                  ))}
                </ul>
              </div>
            </div>
            <button className="param-desc-close-btn" onClick={() => setShowDetailModal(false)}>닫기</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServerStatus; 